import React from "react";
import styles from "./ProjectItem.module.css";

const ProjectItem = (props: {
  key: string;
  title: string;
  date: string;
  image: string;
  url: string;
}) => {
  return (
    <li className={styles.item}>
      <div style={{ marginLeft: 10, marginTop: 10 }}>
        <div className={styles.dateStyle}>{props.date}</div>
        <div className={styles.titleStyle}>
          <a href={props.url} target="_blank" rel="noreferrer">
            {props.title}
          </a>
        </div>
        <div className={styles.titleStyle}>{props.image}</div>
      </div>
    </li>
  );
};

export default ProjectItem;
